import P_Sidebar from './components/sidebar/P_Sidebar';
import useWaSecurityService from 'src/api/wa/service/WaSecurityService';
import { wardsNavigate } from '../router/WardsScreenRegistration';
import { useNavigate } from 'react-router-dom';
import { WA_Screen } from '../router/WardsScreens';
import { WaScreensMap } from '../router/WardsScreenMap';

type P_MainProps = {
  component: React.ReactNode;
};

const P_Main = (props: P_MainProps) => {
  const { waLogoutUser } = useWaSecurityService();

  const navigate = useNavigate();

  const handleEasternSitesListSeleceted = () => {
    wardsNavigate(navigate, WaScreensMap[WA_Screen.UnadressedWorkplacesList].path);
  };

  const handleEasternMapSelected = () => {
    wardsNavigate(navigate, WaScreensMap[WA_Screen.WorkplacesMap].path);
  };

  const handleShowSummarySelected = () => {
    wardsNavigate(navigate, WaScreensMap[WA_Screen.BranchSummary].path);
  };

  const handleLogout = () => {
    waLogoutUser();
  };

  return (
    <div className="m-3 flex space-x-3">
      <P_Sidebar
        sitesListSelected={handleEasternSitesListSeleceted}
        sitesMapSelected={handleEasternMapSelected}
        showSummarySelected={handleShowSummarySelected}
        logoutSelected={handleLogout}
      />
      <main className="h-screen min-w-0 flex-1">{props.component}</main>
    </div>
  );
};

export default P_Main;
